<template>

	<div class="author">
		<img :src="headshot" class="headshot">
		<div class="title" v-html="title"></div>
	</div>

</template>

<script>

	export default {
		name: "author",
		props: ['headshot', 'title']
	}

</script>

<style lang="scss" scoped>

	@import "responsive-font";
	@import "media";

	.author {
		@include responsive-font(10);
		display:flex; align-items:center;
	}

	.title {
		@include responsive-font(14);
		color:rgba(#6D6E71, .5); line-height:1.3;
	}

	.headshot {
		display:block; margin-right:.8em; width:3.5em; height:3.5em;
	}

</style>



// WEBPACK FOOTER //
// src/components/Author.vue